import { z } from 'zod';
/**
 * Cinq populations, un seul mécanisme de connexion (M6) : c'est `role` — et lui seul — qui
 * sépare les périmètres, `login`/`hash` sont communs à tous.
 *
 * ⚠️ `rh` est une 5ᵉ valeur ajoutée sans périmètre expliqué — question ouverte, cf.
 * `docs/MODELE-DONNEES.md` Q9.
 */
export const ROLES = ['agent', 'team', 'back_office', 'admin', 'rh'];
export const roleSchema = z.enum(ROLES);
//# sourceMappingURL=role.js.map